import React, { useState } from "react";
import { View, Text, ScrollView, StyleSheet } from "react-native";
import RegionDropdown from "./religion-dropdown";
import { regionOptions } from "./region-options";
import TouchableOpacityLink from "../touchable-opacity-link";
import { helpers } from "../../utils/helpers";

const MobileScrollMenu = ({ headerData }) => {
  const { header_nav } = headerData || {};
  const pathname = window?.location?.pathname;
  const isMiddleEast = pathname.includes("/middle-east");

  const [showRegionDropdown, setShowRegionDropdown] = useState(false);

  const handleDropdown = (value) => {
    setShowRegionDropdown(false);
    if (value === "middle-east") {
      window.location.href = "/middle-east";
    } else {
      window.location.href = "/";
    }
  };

  if (helpers.isDesktop()) {
    return null;
  }

  return (
    <View
      style={[
        styles.container,
        showRegionDropdown && styles.containerDropdownOpen,
      ]}
    >
      <View style={styles.row}>
        <View
          style={[
            styles.regionWrapper,
            showRegionDropdown && styles.regionWrapperDropdownOpen,
          ]}
        >
          <RegionDropdown
            title={isMiddleEast ? "Middle East" : "India"}
            showDropdownValues={showRegionDropdown}
            onDropdownClick={() => setShowRegionDropdown(!showRegionDropdown)}
            outsideClick={() => setShowRegionDropdown(false)}
            data={regionOptions}
            onDropdownOptionClick={handleDropdown}
          />
        </View>
        <ScrollView
          horizontal
          showsHorizontalScrollIndicator={false}
          style={[
            styles.navScroll,
            showRegionDropdown && styles.navScrollBehindDropdown,
          ]}
          contentContainerStyle={styles.navScrollContent}
        >
          {header_nav?.length > 0 &&
            header_nav?.map((item) => {
              const isActive = pathname === item.url;
              console.log({ isActive, pathname, item });
              return (
                <TouchableOpacityLink
                  key={item.name}
                  to={item.url}
                  //   style={[styles.navLinkWrapper, { marginRight: 10 }]}
                >
                  <Text
                    style={[
                      styles.navLinkText,
                      isActive && styles.navLinkActive,
                    ]}
                  >
                    {item.name}
                  </Text>
                </TouchableOpacityLink>
              );
            })}
        </ScrollView>
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    position: "relative",
    zIndex: 10001,
    paddingHorizontal: 10,
    paddingVertical: 10,
    overflow: "visible",
    shadowColor: "rgba(0, 0, 0, 0.1)",
    shadowOffset: { width: 0, height: 1 },
    shadowOpacity: 1,
    shadowRadius: 2,
    elevation: 1,
  },
  containerDropdownOpen: {
    zIndex: 10050,
    elevation: 10050,
  },
  row: {
    flexDirection: "row",
    alignItems: "flex-start",
    gap: 16,
    overflow: "visible",
    alignItems: "center",
  },
  regionWrapper: {
    flexShrink: 0,
    overflow: "visible",
    zIndex: 2,
  },
  regionWrapperDropdownOpen: {
    zIndex: 10052,
    elevation: 10052,
  },
  navScroll: {
    flex: 1,
    minWidth: 0,
    zIndex: 1,
  },
  navScrollBehindDropdown: {
    zIndex: 0,
  },
  navScrollContent: {
    flexDirection: "row",
    alignItems: "center",
    gap: 20,
    paddingRight: 10,
  },
  navLinkWrapper: {
    flexShrink: 0,
  },
  navLinkText: {
    color: "#292929",
    fontFamily: "HaasGrotesk-Roman",
    fontWeight: "400",
    fontSize: 13,
    letterSpacing: 1,
    textTransform: "uppercase",
  },
  navLinkActive: {
    textDecorationLine: "underline",
    textDecorationColor: "#2cb680",
    textDecorationStyle: "solid",
    textDecorationThickness: 2,
    textUnderlineOffset: 6,
    textDecorationStyle: "solid",
  },
});

export default MobileScrollMenu;
